import { jsx as _jsx } from "react/jsx-runtime";
import { StepIndicator } from "components/Common/StepIndicator";
import { FormattedMessage } from "react-intl";
const RESETPW_LABELS = [
    _jsx(FormattedMessage, { id: "stepIndicator.resetpwStep1", description: "resetpw step1", defaultMessage: "Enter email address" }, "step1"),
    _jsx(FormattedMessage, { id: "stepIndicator.resetpwStep2", description: "resetpw step2", defaultMessage: "Confirm Captcha" }, "step2"),
    _jsx(FormattedMessage, { id: "common.verifyEmailAddress", description: "resetpw step3", defaultMessage: "Verify email address" }, "step3"),
    _jsx(FormattedMessage, { id: "stepIndicator.resetpwStep4", description: "resetpw step4", defaultMessage: "Verification method" }, "step4"),
    _jsx(FormattedMessage, { id: "stepIndicator.resetpwStep5", description: "resetpw step5", defaultMessage: "Set password" }, "step5"),
    _jsx(FormattedMessage, { id: "common.completed", description: "resetpw step6", defaultMessage: "Completed" }, "step6"),
];
export function ResetPasswordStepIndicator({ currentStep, }) {
    return _jsx(StepIndicator, { currentStep: currentStep, totalSteps: 6, labels: RESETPW_LABELS });
}
